export default {
	data() {
		return {
			validationRulesPassword: [
				{
					message: "6 to 10 characters long",
					regex: /^.{6,10}$/
				},
				{
					message: "At least 2 letters",
					regex: /[a-zA-Z].*[a-zA-Z]/
				},
				{
					message: "At least 2 numbers",
					regex: /[0-9].*[0-9]/
				},
				{
					message: "No special characters",
					regex: /^[a-zA-Z0-9]*$/,
					isNegative: true
				}
			]
		};
	}
};
